import { LineType, LineDistance, CircleDisplayType } from './line-markers.enum';
import './style.scss';

function LineMarker({
  foregroundColor,
  backgroundColor,
  lineColor,
  lineType,
  lineDistance = LineDistance.full,
  circleDisplayType,
  secondaryLineColor = undefined,
  fadeSecondaryLineColor = false,
  className = undefined,
}: {
  foregroundColor: string;
  backgroundColor: string;
  lineColor: string;
  lineType: LineType;
  lineDistance?: LineDistance;
  circleDisplayType: CircleDisplayType;
  secondaryLineColor?: string;
  fadeSecondaryLineColor?: boolean;
  className?: string;
}) {
  return (
    <div className={`line-marker position-relative ${className ?? ''}`}>
      {(circleDisplayType === CircleDisplayType.firstOnly || circleDisplayType === CircleDisplayType.both || circleDisplayType === CircleDisplayType.center) && (
        <div
          className={`line-marker__dot position-absolute ${circleDisplayType === CircleDisplayType.center ? 'line-marker__dot--center' : 'line-marker__dot--first'}`}
          style={{ backgroundColor: foregroundColor }}
        >
          <div
            className={`line-marker__inner-dot position-absolute ${circleDisplayType === CircleDisplayType.center ? 'line-marker__inner-dot--center' : 'line-marker__inner-dot--first'}`}
            style={{ backgroundColor }}
          ></div>
        </div>
      )}
      <div
        className={`line-marker__line ${lineDistance === LineDistance.halfStart ? 'line-marker__line--half' : ''} ${
          lineDistance === LineDistance.halfEnd ? 'line-marker__line--half line-marker__line--no-bottom' : ''
        } position-absolute`}
        style={{ borderLeftColor: lineColor, borderLeftStyle: lineType }}
      ></div>
      {secondaryLineColor && (
        <div
          className={`line-marker__line-secondary ${lineDistance === LineDistance.halfStart ? 'line-marker__line-secondary--start' : 'line-marker__line-secondary--end'} position-absolute`}
          style={{
            borderLeftStyle: lineType,
            borderLeftColor: !fadeSecondaryLineColor ? secondaryLineColor : undefined,
            borderImage: fadeSecondaryLineColor
              ? lineDistance === LineDistance.halfStart
                ? `linear-gradient(180deg, ${secondaryLineColor}, #fff) 1`
                : `linear-gradient(180deg, #fff, ${secondaryLineColor}) 1`
              : undefined,
          }}
        ></div>
      )}
      {(circleDisplayType === CircleDisplayType.secondOnly || circleDisplayType === CircleDisplayType.both) && (
        <div className="line-marker__dot line-marker__dot--second position-absolute" style={{ backgroundColor: foregroundColor }}>
          <div className="line-marker__inner-dot line-marker__inner-dot--second position-absolute" style={{ backgroundColor }}></div>
        </div>
      )}
    </div>
  );
}

export default LineMarker;
